import request from "@/utils/request.js";

/**
 * 用户反馈问题
 * @param params
 * @returns {AxiosPromise}
 */
export function addCorrelationQuestion(params) {
  return request({
    url: "/operateService/api/app/onlineQa/addCorrelationQuestion",
    method: "post",
    data: params
  });
}
/**
 * 相关问题分页
 * @param params
 * @returns {AxiosPromise}
 */
export function appCorrelationQuestionListPage(params) {
  return request({
    url: "/operateService/api/app/onlineQa/appCorrelationQuestionListPage",
    method: "post",
    data: params
  });
}
/**
 * 常见问题分页
 * @param params
 * @returns {AxiosPromise}
 */
export function appFamiliarQuestionListPage(params) {
  return request({
    url: "/operateService/api/app/onlineQa/appFamiliarQuestionListPage",
    method: "post",
    data: params
  });
}
/**
 * 问题详情
 * @param params
 * @returns {AxiosPromise}
 */
export function getAddCorrelationQuestion(params) {
  return request({
    url: "/operateService/api/app/onlineQa/getAddCorrelationQuestion",
    method: "post",
    data: params
  });
}
/**
 * 是否点击过
 * @param params
 * @returns {AxiosPromise}
 */
export function hasClickBeUse(params) {
  return request({
    url: "/operateService/api/app/onlineQa/hasClickBeUse",
    method: "post",
    data: params
  });
}
/**
 * 点击有用无用
 * @param params
 * @returns {AxiosPromise}
 */
export function useClickBeUse(params) {
  return request({
    url: "/operateService/api/app/onlineQa/useClickBeUse",
    method: "post",
    data: params,
    showLoading: true
  });
}
/**
 * 我的反馈列表
 * @param params
 * @returns {AxiosPromise}
 */
export function userFeedbackListPage(params) {
  return request({
    url: "/operateService/api/app/onlineQa/userFeedbackListPage",
    method: "post",
    data: params,
    showLoading: true
  });
}
